var map = {
	"./EHS-losses.svg": 1346,
	"./FTE-breakdown.svg": 1347,
	"./add-plant-popup.svg": 383,
	"./assign.svg": 1348,
	"./available-training-course.svg": 1349,
	"./blue-close-icon.svg": 1350,
	"./cancel-dark.svg": 1351,
	"./cir-select-chk.svg": 1352,
	"./clear-overview-search.svg": 300,
	"./computer-screen-with-solutions.svg": 1353,
	"./cross-btn.svg": 1354,
	"./ddl-trangle.svg": 301,
	"./demo-user.svg": 1355,
	"./digital-label-icon.svg": 1356,
	"./disabled-btn.svg": 1357,
	"./done-check.png": 1358,
	"./email-list-cancel.svg": 1359,
	"./exclude.svg": 1360,
	"./eye.svg": 1361,
	"./finance-data.svg": 1362,
	"./general-information.svg": 1363,
	"./industry-ico.svg": 1364,
	"./industry-vision-dm.svg": 1365,
	"./it-losses.svg": 1366,
	"./loss-analysis-label-icon.svg": 1367,
	"./loss-label-icon.svg": 1368,
	"./maintenance-losses.svg": 1369,
	"./manufacturing-cost.svg": 1370,
	"./material-waste.svg": 1371,
	"./md8-cybersecurity-data-architecture.svg": 1372,
	"./md8-ehs.svg": 1373,
	"./md8-industry -4.0-vision.svg": 1374,
	"./md8-information-systems.svg": 1375,
	"./md8-maintenance.svg": 1376,
	"./md8-op-ex.svg": 1377,
	"./md8-production-execution.svg": 1378,
	"./md8-quality.svg": 1379,
	"./md8-warehouse-material-handling.svg": 1380,
	"./minor-stops.svg": 1381,
	"./minus.svg": 655,
	"./more-icon.svg": 1382,
	"./ms-assign-search.svg": 1383,
	"./ms-unsaved.svg": 1384,
	"./my-training.svg": 1385,
	"./operator-losses.svg": 1386,
	"./overview-assign-img.svg": 656,
	"./planned-downtime.svg": 1387,
	"./plant-circle.svg": 1388,
	"./plant.svg": 657,
	"./plants-label-icon.svg": 1389,
	"./product-tab-img.svg": 1390,
	"./quality-losses.svg": 1391,
	"./report-problem.svg": 1392,
	"./speed-losses.svg": 1393,
	"./submit-animation.png": 1394,
	"./td-search-icon.svg": 302,
	"./toggle-icon.svg": 1395,
	"./training-course.svg": 1396,
	"./unplanned-downtime.svg": 1397,
	"./user-circle.svg": 1398,
	"./user.svg": 658,
	"./verify-email-check.svg": 1399,
	"./warehouse-losses.svg": 1400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 299;